import React, { FC } from 'react';
import styled from 'styled-components';
import { BodyShort01, Text02 } from 'components/styles';
import { Task } from 'data/tasks';
import { getDisplayTaskName } from './utils';

const TaskTitle = styled.div`
  flex: 1;
  line-height: var(--spacing-06);
  width: 100%;
  ${BodyShort01};
  ${Text02};
`;

export const TaskCardTitle: FC<{
  task: Task;
  rows?: number;
}> = ({ task, rows = 2 }) => (
  <TaskTitle>{getDisplayTaskName(task, rows)}</TaskTitle>
);
